import { observer } from "mobx-react";
import React, { FC, useCallback, useMemo } from "react";
import { Box, Checkbox, HStack } from "@chakra-ui/react";
import { LeadAttributionStatusEnum } from "enums/account-lead-attribution.enum";

interface IProps {
  status: LeadAttributionStatusEnum;
  isChecked: (status: LeadAttributionStatusEnum) => boolean;
  onChange: (event: string) => void;
  isDisabled: (status: LeadAttributionStatusEnum) => boolean;
}

export const LeadAttributionPeopleGroupSubFilterItem: FC<IProps> = observer(
  ({ isDisabled, isChecked, onChange, status }) => {
    const handleOnChange = useCallback(
      async (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value);
      },
      [onChange]
    );

    const checked = useMemo(() => {
      return isChecked(status);
    }, [isChecked, status]);

    const disabled = useMemo(() => {
      return isDisabled(status);
    }, [isDisabled, status]);

    return (
      <HStack key={status}>
        <Box fontSize={"xs"}>{status}</Box>
        <Checkbox
          disabled={disabled}
          onChange={handleOnChange}
          isChecked={checked}
          value={status}
        />
      </HStack>
    );
  }
);
